import { IDropDownItem } from "./drop-down-item";
import { ICenterCompliance } from '../../models/center-performance';

export interface IAnatomyPrefsData {
    // anatomyMaxPreferencesRight: IDropDownItem[];
    // anatomyMaxPreferencesLeft: IDropDownItem[];
    anatomyPrefArteriesLeft?: number;
    anatomyPrefArteriesLeftDate?: string;
    anatomyPrefArteriesRight?: number;
    anatomyPrefArteriesRightDate?: string;
    anatomyPrefVeinsLeft?: number;
    anatomyPrefVeinsLeftDate?: string;
    anatomyPrefVeinsRight?: number;
    anatomyPrefVeinsRightDate?: string;
    complianceWaitListAnatomy: ICenterCompliance;

}